import { render, staticRenderFns } from "./cEpps.vue?vue&type=template&id=8ff0e972&scoped=true"
import script from "./cEpps.vue?vue&type=script&lang=js"
export * from "./cEpps.vue?vue&type=script&lang=js"
import style0 from "./cEpps.vue?vue&type=style&index=0&id=8ff0e972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0e972",
  null
  
)

export default component.exports